enum HooksModalV2Key {
    Empty = "",
    WebCountry = "WebCountry",
    WebAllowedDuration = "WebAllowedDuration",
}

export default HooksModalV2Key;
